<main class="container" id="main" data-testid="app-home">
    <div class="container__inner">
        <div class="grid grid--home">
            <!-- Scope Card — Welcome Variant -->
            <div class="card-main grid__item">
                <app-scope-card class="flex"></app-scope-card>
            </div>

            @if (showInsideScopeBanner) {
                <!-- Inside Scope Banner -->
                <div class="inside-scope-banner">
                    <mat-card class="riege-card">
                        <a
                            class="link--box-shadow"
                            href="https://events.riege.com/inside-scope-2026"
                            target="_blank"
                            (click)="trackBannerClick($event, 'Inside Scope Banner Container')">
                            <picture>
                                <source
                                    media="(max-width: 600px)"
                                    srcset="assets/images/ship_banner_neu_1280x720.jpg" />
                                <img mat-card-image src="assets/images/ship_banner_neu_1128x352.jpg" alt="" />
                            </picture>
                            <mat-card-content>
                                <mat-card-title i18n="@@inside-scope-banner-headline">
                                    Inside Scope 2026 | June 9–10, 2026
                                </mat-card-title>
                                <p class="mat-card__infotext" i18n="@@inside-scope-banner-infotext"
                                    >Join us for two unforgettable days of learning, networking, and inspiration in a
                                    setting like no other: the legendary ss Rotterdam.</p
                                >
                            </mat-card-content>
                            <mat-card-actions>
                                <a
                                    class="riege-button"
                                    mat-flat-button
                                    i18n="@@inside-scope-banner-cta"
                                    href="https://events.riege.com/en/inside-scope-2026"
                                    (click)="trackBannerClick($event, 'Inside Scope Banner Button')"
                                    >Save your ticket now</a
                                >
                            </mat-card-actions>
                        </a>
                    </mat-card>
                </div>
            }

            @if (showCommunityHeroBanner && authService.isLoggedIn()) {
                <div class="home-teaser">
                    <div class="row is-desktop is-multiline">
                        <div class="column is-12-tablet is-6-desktop">
                            <div class="row is-desktop is-multiline">
                                <div class="column is-12">
                                    <img
                                        src="assets/images/business-partner.jpg"
                                        aria-hidden="true"
                                        alt="Business partners" />
                                </div>
                            </div>
                        </div>
                        <div class="column is-12-tablet is-5-desktop is-offset-1-desktop align-self--center">
                            <div class="home-teaser__column-content">
                                <h2 class="header" i18n="@@scope-community-home-teaser-heading"
                                    >Connect with logistics professionals</h2
                                >
                                <p class="margin-bottom--base" i18n="@@scope-community-home-teaser-description"
                                    >Explore the Scope Community. Discover how you can increase your visibility, find
                                    new partners, and expand your business.</p
                                >

                                <div class="row is-multiline">
                                    <div class="column is-full">
                                        <a
                                            mat-stroked-button
                                            class="riege-button"
                                            [routerLink]="['./scope-community', 'community-members']">
                                            <span i18n="@@scope-community-button-partners-discover-community"
                                                >Discover the community</span
                                            >
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <div class="home-teaser">
                    <div class="row is-desktop is-multiline">
                        <div class="column is-12-tablet is-6-desktop">
                            <div class="row is-desktop is-multiline">
                                <div class="column is-12">
                                    <img
                                        src="assets/images/business-partner.jpg"
                                        aria-hidden="true"
                                        alt="Business partners" />
                                </div>
                                <div class="column is-12">
                                    <div class="home-teaser__column-content">
                                        <h2 class="header" i18n="@@scope-community-home-teaser-heading"
                                            >Connect with logistics professionals</h2
                                        >
                                        <p class="margin-bottom--base" i18n="@@scope-community-home-teaser-description"
                                            >Explore the Scope Community. Discover how you can increase your visibility,
                                            find new partners, and expand your business.</p
                                        >

                                        <div class="row is-multiline">
                                            <div class="column is-full">
                                                <a
                                                    mat-stroked-button
                                                    class="riege-button"
                                                    [routerLink]="['./scope-community', 'community-members']"
                                                    [queryParams]="{ view: 'map' }">
                                                    <span i18n="@@scope-community-button-partners-discover-community"
                                                        >Discover the community</span
                                                    >
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="column is-12-tablet is-6-desktop">
                            <div class="row is-desktop is-multiline">
                                <div class="column is-12">
                                    <img
                                        src="assets/images/scope-hub-dummy.jpg"
                                        aria-hidden="true"
                                        alt="Business partners" />
                                </div>
                                <div class="column is-12">
                                    <div class="home-teaser__column-content">
                                        <h2 class="header" i18n="@@scope-community-infobox-heading-dummy">
                                            Your software for digital logistics
                                        </h2>
                                        <p
                                            class="margin-bottom--base"
                                            i18n="@@scope-community-infobox-description-dummy">
                                            Position yourself as a digital freight forwarder with Scope and expand your
                                            network with thousands of logistics specialists worldwide.
                                        </p>

                                        <div class="row is-multiline">
                                            <div class="column is-full">
                                                <a
                                                    mat-stroked-button
                                                    class="riege-button"
                                                    href="https://www.riege.com/"
                                                    target="_blank">
                                                    <span i18n="@@scope-community-button-partners-gtk-scope"
                                                        >Get to know Scope</span
                                                    >
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- News & Release Reports -->
            @if (hasPosts()) {
                @if (hasReleaseItems()) {
                    <div
                        class="release release--new flex flex-direction--column"
                        aria-labelledby="release"
                        [ngClass]="hasBlogItems() ? 'grid--one-third-desktop' : 'grid--three-thirds-desktop'">
                        <riege-news
                            class="flex"
                            [feed]="'release-reports'"
                            [count]="1"
                            (hasPosts)="hasReleaseItems.set($event)"
                            variant="release"
                            data-testid="release-reports">
                        </riege-news>
                    </div>
                }

                @if (hasBlogItems()) {
                    <div class="blog flex flex-direction--column grid--three-thirds-desktop" aria-labelledby="blog">
                        <h2 id="blog" i18n="@@card-headline-blog">The latest from the Riege blog</h2>
                        <div class="blog__inner flex">
                            <riege-news
                                class="flex"
                                [feed]="'blog'"
                                [count]="3"
                                (hasPosts)="hasBlogItems.set($event)"
                                data-testid="blog-news"></riege-news>
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</main>
<!-- container-->
